import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {PropertyDetailState} from '@local/redux/state/pages/propertyDetail';

const initialState: PropertyDetailState = {
  edit_current_tenant: false,
  edit_next_tenant: false,
  processing: false,
};
const propertyDetailSlice = createSlice({
  name: 'propertyDetail',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Partial<PropertyDetailState>>) => {
      return {...state, ...action.payload};
    },
    setSendDialogState: (state, action: PayloadAction<PropertyDetailState['ticketSendDialogState']>) => {
      return {
        ...state,
        ticketSendDialogState: {
          ...state.ticketSendDialogState,
          ...action.payload,
        },
      };
    },
    setHistoryDialogState: (state, action: PayloadAction<PropertyDetailState['ticket_history_dialog_state']>) => {
      return {
        ...state,
        ticket_history_dialog_state: {
          ...state.ticket_history_dialog_state,
          ...action.payload,
        },
      };
    },
    clear: () => initialState,
  },
});
export const propertyDetailReducer = propertyDetailSlice.reducer;
export const propertyDetailActions = propertyDetailSlice.actions;
